import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/card";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";

export default function CheckoutCardView({
  register,
  handleSubmit,
  errors,
  goBack,
  isDisabled,
  error,
  isLoading,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <form className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form" onSubmit={handleSubmit}>
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          {error && <div className="flex w-full flex-col">
            <h2 className="text-2xl text-center font-bold">Houve um problema ao tentar realizar seu pagamento</h2>
            <h3 className="text-lg text-center">Clique no botão para tentar novamente</h3>
          </div>}
          {!error && <div>
            <h2 className="mt-6 text-black text-xl">Cartão de crédito</h2>
            <h3 className="text-black text-sm">Novo cartão</h3>
            <h4 className="text-black text-sm">Informe seus dados nos campos abaixo</h4>
            <div className="flex flex-col justify-center items-center">
              <div className="w-full">
                <InputMask
                  {...register("number")}
                  name="number"
                  required
                  type="text"
                  inputMode="numeric"
                  mask="____ ____ ____ ______"
                  replacement={{ _: /\d/ }}
                  placeholder="Número do cartão"
                  className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <div className="h-4">
                  {errors.number && (
                    <span className="text-red-500 text-xs">{errors.number.message as string}</span>
                  )}
                </div>
              </div>
              <div className="w-full">
                <input
                  {...register("name")}
                  required
                  type="text"
                  name="name"
                  placeholder="Nome no cartão"
                  className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <div className="h-4">
                  {errors.name && (
                    <span className="text-red-500 text-xs">{errors.name.message as string}</span>
                  )}
                </div>
              </div>
              <div className="w-full">
                <InputMask
                  {...register("expiration")}
                  name="expiration"
                  required
                  type="text"
                  inputMode="numeric"
                  mask="__/____"
                  replacement={{ _: /\d/ }}
                  placeholder="Vencimento MM/AAAA"
                  className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <div className="h-4">
                  {errors.expiration && (
                    <span className="text-red-500 text-xs">{errors.expiration.message as string}</span>
                  )}
                </div>
              </div>
              <div className="w-full">
                <InputMask
                  {...register("document")}
                  name="document"
                  required
                  type="text"
                  inputMode="numeric"
                  mask="___.___.___-__"
                  replacement={{ _: /\d/ }}
                  placeholder="CPF"
                  className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <div className="h-4">
                  {errors.document && (
                    <span className="text-red-500 text-xs">{errors.document.message as string}</span>
                  )}
                </div>
              </div>
            </div>
          </div>}
          <Button
            title={error ? "Tentar novamente" : "Finalizar"}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </form>
      {isLoading && <Loading />}
    </div>
  );
}